import IconButton from "@material-ui/core/IconButton/IconButton";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { api } from "@portal/arq-portal-core";
import React from "react";
import { useSWRConfig } from "swr";

const useEstilos = makeStyles((theme) => ({
    itemContainer: { 
        display: 'flex', 
        flex: 'auto', 
        justifyContent: 'space-between'
    },
    linkContainer: { 
        display: 'flex', 
        alignItems: 'center',
        fontSize: '12px',
        color: theme.palette.primary.main,
        '& i': {
            fontSize: '28px',
            lineHeight: '0.8',
        },
        '& span': {
            borderBottom: '1px solid #DC0028'
        }
    },
    deleteContainer:{
        '& i': {
            fontSize: '28px',
            lineHeight: '0.8',
        },
    },
    linkFolder:{
        display: 'flex', 
        alignItems: 'center',
        fontSize: '12px',
        color: '#606060',
        '& i': {
            fontSize: '28px',
            lineHeight: '0.8',
        },
        '& span': {
            borderBottom: '0px solid transparent'
        },
        '&:hover span': {
            color: '#919191',
        },
        '&:active span, &:focus span': {
            color: '#DC0028',
        }
    },
    icon: { 
        width: '0.75em'
    }
}));

interface SoftwareListItemProps {
    item: any;
    onFolderNavigation: () => void;
    onItemDelete: () => void;
}

export const SoftwareItem = (props: SoftwareListItemProps) => {
    
    const clases = useEstilos(props);
    let { item, onFolderNavigation, onItemDelete } = props;
    const { mutate } = useSWRConfig();
    
    const handleDelete = (id:any) => {
        mutate(["eliminardescargasoftware"], ()=>api.post("/be/eliminardescargasoftware/", {Entrada:{IdDocumento: id}}), false);
        onItemDelete();
    }

    const renderIcon = (type:string) => {
        switch(type.toLowerCase()){
            case "xls":
            case "xlsx":
            case "ppt":
            case "txt":
            case "docx":
            case "doc":
            case "csv":
            case "sql":
            case "cyl":
            case "pdf":
            case "carpeta":
                return <i className={`icon-${type}`}></i>;
            default:
                return <i className="icon-encargo-gen"></i>;
        }
    }

    const handleGoFolder = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        onFolderNavigation();
    }

    return (
        <div className={clases.itemContainer}>
            {
                item.IsFolder === "True"
                ?
                    <a href="#" className={clases.linkContainer +' '+ clases.linkFolder } onClick={ (e) => handleGoFolder(e) } >{renderIcon(item.Icono)} <span>{item.Titulo} ({item?.Documentos?.length??"0"})</span></a>
                :
                    <a href={`${item.Url}`} target="_blank" className={clases.linkContainer} >{renderIcon(item.Icono)} <span>{item.Titulo}</span></a>
            }
            {item.IsFolder === "False" && <IconButton className={"widgetIcon"} aria-label="open" component="span" onClick={() => handleDelete(item.Id)}>
                <i className="icon-papelera"/>
            </IconButton>}
        </div>
    );

}